import styled from 'styled-components/macro'

export const WomanContainer = styled.div`
  overflow-y: clip;
`
export const SilhouettesContainer = styled.div`
  position: relative;
  @media (max-width: 1024px) {
    aspect-ratio: 351/93;

    width: 100%;
    img {
      position: absolute;
      bottom: 0;
      width: 100%;
    }
  }
`

export const CarContainer = styled.div`
  overflow-y: clip;
  img {
    @media (max-width: 1024px) {
      width: 100%;
    }
  }
`
